import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { DialogForm, IDialogActions, ISnackbarAlert, SnackbarAlert, TextFieldReadOnly } from '..';
import { GenericService } from '../../services';

interface IDeleteProps {
    entity: string;
    data: string;
    setIsOpenDiaglog: (value: boolean) => void;
    isOpenDialog: boolean;
    setActionExecuted: (value: true) => void;
    indexAttributeLabel?: number;
}

export const Delete: React.FC<IDeleteProps> = ({ data, isOpenDialog, setIsOpenDiaglog, entity, setActionExecuted, indexAttributeLabel }) => {
    const [id, setId] = useState('');
    const [name, setName] = useState('');

    const [loading, setLoading] = useState(false);
    const [snackBarAlert, setSnackBarAlert] = useState<ISnackbarAlert>();
    const [isOpenMessage, setIsOpenMessage] = useState(false);

    useEffect(() => {
        handleGetById(data);
    }, [data]);

    const handleGetById = async (data: any) => {

        if (data === '') { return; }

        //GenericService.GetByIdAsync1('parmsphere.list', data.id, setLoading, () => void undefined, showMessage);


        try {
            setLoading(oldValue => !oldValue);

            const identification = `id=${data.id}`;

            const result: any = await GenericService.GetByIdAsync(identification, entity.charAt(0).toUpperCase() + entity.slice(1));

            if (result instanceof Error) { throw new Error(result.message); }

            if (result.code === 200 && result.value !== null) {
                setId(result.value.id);
                setName(result.value.name);
            } else {
                showMessage(result.info, 'info');
            }
            setLoading(false);
        } catch (error) {
            showMessage(String(error), 'error');
        }
    };

    const handleConfirmDeleteClick = async () => {

        try {
            setLoading(oldValue => !oldValue);

            const identification = `id=${id}`;

            const result: any = await GenericService.DeleteAsync(identification, entity);

            if (result instanceof Error) { throw new Error(result.message); }

            if (result.code === 200 && result.value === null) {
                setActionExecuted(true);

                showMessage(result.info, 'success');
            } else {
                showMessage(result.info, 'info');
            }
            setLoading(false);
        } catch (error) {
            showMessage(String(error), 'error');
        }
    };

    function showMessage(message: string, type: 'error' | 'info' | 'success' | 'warning') {
        const msg: ISnackbarAlert = {
            id: 'message',
            message: message,
            type: type,
        };
        setSnackBarAlert(msg);
        setIsOpenMessage(true);
    }

    const actions: IDialogActions[] = [
        { id: 'cancel', text: 'Cancel', icon: 'cancel_outlined', iconColor: 'primary', setAction: () => void undefined },
        { id: 'confirm', text: 'Confirm', icon: 'save_outlined', iconColor: 'warning', setAction: handleConfirmDeleteClick },
    ];

    return (
        <React.Fragment>
            <SnackbarAlert
                snackBarAlert={snackBarAlert}
                setIsOpen={setIsOpenMessage}
                isOpen={isOpenMessage}
            />
            <DialogForm
                title='Confirm Deletion?'
                icon='delete_outlined'
                iconColor='error'
                setIsOpen={setIsOpenDiaglog}
                isOpen={isOpenDialog}
                fullWidth={true}
                maxWidth={'sm'}
                actions={actions}
                loading={loading}
            >
                <React.Fragment>
                    <Grid container justifyContent={'center'} pl={2} justifySelf={'center'}>
                        <Grid item xs={12} md={12}>
                            <TextFieldReadOnly
                                id='text'
                                label=''
                                value={'Confirm the deletion of Record: ' + (name ?? Object.values<any>(data)[indexAttributeLabel ?? 1].valueOf())}
                                hasDivider={false}
                            />
                        </Grid>
                    </Grid>
                </React.Fragment>
            </DialogForm >
        </React.Fragment >
    );
};